import { FC } from "react";
import { StructuresGroupFilter } from "./StructuresGroupsFilter";
import { StructuresTypesFilter } from "./StructuresTypesFilter";
import { NetworkTypeFilter } from "./NetworkTypeFilter";
import { ActiveFilter } from "./ActiveFilter";
import { ListFilters } from "@/types/list";

type StructuresTypesFilterProps = {
	filter: ListFilters;
	hideTypes?: boolean;
	hideNetworkType?: boolean;
	hideActivity?: boolean;
};

export const StructureFilters: FC<StructuresTypesFilterProps> = ({
	filter,
	hideTypes = false,
	hideNetworkType = false,
	hideActivity = false,
}) => {
	return (
		<div className="flex items-end gap-2">
			<StructuresGroupFilter filter={filter} />
			{!hideTypes && <StructuresTypesFilter filter={filter} />}
			{!hideNetworkType && <NetworkTypeFilter filter={filter} />}
			{!hideActivity && <ActiveFilter filter={filter} />}
		</div>
	);
};
